// here we add all base urls and keys

// Base URLS
export const base_uri = process.env.REACT_APP_API_BASE_URL;
export const s3baseUrl = process.env.REACT_APP_PIC_BASE_URL;

// Keys
// export const secret_key = process.env.REACT_APP_API_SECRET_KEY;
